<template>
  <v-container fluid>
    <section class="intro-section" id="home">
      <v-row class="align-center px-10" style="height: 690px">
        <v-col cols="12" md="6" class="pa-1 font-weight-bold py-16">
          <h2 class="display-2">Call <span class="green--text">Constituents</span> & <span
              class="pink--text">Hear</span>
            Them Out</h2>
          <v-subheader>We give you access to the voters.</v-subheader>
          <br>
          <br>
          <v-btn large elevation="5" color="green" to="/login" class="white--text mt-10 px-10 py-5">Log in</v-btn>
          <!--          <v-btn large elevation="5" color="pink" class="white&#45;&#45;text mt-10 ml-10 px-10 py-5">Contact Us-->
          <!--          </v-btn>-->
          <v-row class="mt-16 hidden-sm-and-down">
            <v-chip class="px-4 ma-3" color="primary">
              <v-icon left size="20">mdi-facebook</v-icon>
              Facebook
            </v-chip>
            <v-chip class="px-4 ma-3 white--text" color="#01ff56">
              <v-icon left size="20">mdi-whatsapp</v-icon>
              WhatsApp
            </v-chip>
            <v-chip class="px-4 ma-3" color="info">
              <v-icon left size="20">mdi-instagram</v-icon>
              Instagram
            </v-chip>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-card-text class="">
            <h3 class="text-center headline">Don't Have an Account Yet?</h3>
            <h6
                class="text-center caption"
            >Let's get you all set up so you can start creating your your first<br> message campaign
            </h6>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="8">
                <v-form ref="form">
                  <v-text-field
                      label="Full Names"
                      outlined
                      dense
                      color="blue"
                      autocomplete="false"
                      class="mt-16"
                      v-model="userForm.name"
                      :rules="notEmpty"
                  />
                  <v-text-field
                      label="Email"
                      outlined
                      dense
                      v-model="userForm.email"
                      color="blue"
                      autocomplete="false"
                      class=""
                      :rules="emailRules"
                  />
                  <v-text-field
                      label="Phone Number"
                      outlined
                      dense
                      v-model="userForm.phone"
                      color="blue"
                      autocomplete="false"
                      class=""
                      :rules="phoneRules"
                  />
                  <v-text-field
                      label="ID Number"
                      outlined
                      v-model="userForm.idnumber"
                      dense
                      color="blue"
                      autocomplete="false"
                      class=""
                      :rules="notEmpty"
                  />
                  <v-row>
                    <v-col cols="12" sm="7">
                      <v-checkbox
                          :rules="notEmpty"
                          label="I Accept TNC's"
                          class="mt-n1"
                          color="blue"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <span class="caption blue--text ml-n4"><router-link
                          to="/terms">Terms &Conditions</router-link></span>
                    </v-col>
                  </v-row>
                  <v-btn color="blue" dark block tile @click="register">Register</v-btn>
                </v-form>

              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import {postRequest} from "@/api/apirepository";

export default {
  name: "Register",
  metaInfo: {
    title: 'Register',
  },
  data() {
    return {
      userForm: new Form({
        'name': "",
        "email": "",
        "phone": "",
        "idnumber": "",
        "terms": false
      }),
      notEmpty: [
        v => !!v || 'Field is required',
      ],
      phoneRules: [
        v => !!v || 'Phone number is required',
        v => (v && v.length === 10) || 'Phone must be exactly 10 digits',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  methods: {
    register() {
      if (this.$refs.form.validate()) (
          postRequest('register', this.userForm).then(e => {
            this.userForm.reset()
            this.$router.push({
              name: "Login"
            })
          }).catch(e => {
            swal.fire('Error', 'Something went Wrong, Try Again', 'error')
          })
      )
    }
  }
}
</script>

<style scoped>

</style>